import React from "react";
import ReportsOperations from "./comp/reportsOperations/ReportsOperationsConnector";
import ReportEditorContainer from "./comp/reportEditorContainer/ReportEditorContainerConnector";
import "./manageReportsPage.scss";

class ManageReportsPage extends React.Component {
  componentWillMount() {
    document.title = "Reports";
  }

  render() {
    return (
      <div className="manage-reports__page react-page">
        <h1>Reports</h1>
        <hr />
        <ReportEditorContainer />
        <ReportsOperations />
      </div>
    );
  }
}

export default ManageReportsPage;



// WEBPACK FOOTER //
// ./src/components/manageReports/ManageReportsPage.js